import Vue from "vue";

export default {
  getTeams({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);

      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
        ...(state.filterValue != "" && { status: state.filterValue }),
      };

      Vue.$http
        .get("/organization/teams", { params })
        .then(response => {
          commit("teams", response.data.results);
          commit("totalTeams", response.data.total);
          commit("tableLoader", false);

          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },

  fetchTeamsByBranches(_, params) {
    return new Promise((resolve, reject) => {
      // const params = {
      //   page: state.currentPage,
      //   perPage: state.perPage,
      //   ...(state.searchQuery != "" && { search_query: state.searchQuery }),
      //   ...(state.filterValue != "" && { status: state.filterValue })
      // };

      Vue.$http
        .get("/organization/teams", { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getATeam({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/organization/teams/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },

  getAllBranches({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/organization/branches")
        .then(response => {
          // backend now always wraps the branch list as { results, total }
          commit("branches", response.data.results || response.data);
          resolve(response);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  handleSizeChange({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    commit("currentPage", 1);
    dispatch("getTeams");
  },

  handleCurrentChange({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getTeams");
  },

  createTeam({ commit }, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/organization/teams`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
          commit("tableLoader", false);
        });
    });
  },

  updateTeam({ commit }, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/organization/teams/${params.id}`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
          commit("tableLoader", false);
        });
    });
  },

  deleteTeam({ commit }, payload) {
    commit("tableLoader", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/organization/teams/delete`, payload)
        .then(response => {
          resolve(response);
          commit("tableLoader", false);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
          commit("tableLoader", false);
        });
    });
  },

  getEmployees({ commit }, search_query) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);

      const params = {
        search_query,
      };

      Vue.$http
        .get("/organization/employees", { params })
        .then(response => {
          commit("employees", response.data.results);
          commit("totalEmployees", response.data.total);
          commit("tableLoader", false);

          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
};
